<div class="container-fluid p-1 mt-3">
 
  <div class="container-fluid p-0">
    <!-- entete de la page -->
    <div class="row no-gutters">
      <div class="col-3 col-sm-12 col-md-12 col-lg-3 mb-4">
        <h4><i class="fas fa-mail-bulk q-c-main"></i> {{textFilAriane}}</h4>
      </div>
      <div class="col-9 col-sm-12 col-md-12 col-lg-9 ">
        <div class="ariane row no-gutters align-items-center position-relative">
          <div class="line col-8 col-sm-12 col-md-12 col-lg-8"></div>
          <div class="circles offset-md-2 col-12 col-md-4 position-absolute h-100">
            <ul class="row no-gutters h-100 w-100 justify-content-between">
              <li *ngFor="let link of mailService.tabs; let i = index" class="h-100 position-relative" style="cursor:pointer">
                <div class="title position-absolute text-center" [ngClass]="{'selectTitle': link.Active}">
                  {{link.Title}}
                </div>
                <a [class]="link.Class" (click)="GetStep(link)" class="h-100 w-100">
                  <div class="h-100 w-100 circle d-flex flex-column justify-content-center text-center" [ngClass]="{'select': link.Active}" title="{{link.Name}}">
                    <div [innerHtml]="link.Icon">
                    </div>
                  </div>
                  <div class="sonar-wave" *ngIf="pulseButton && link.Sonar"></div>
                </a>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <br />
    <!-- contenue de la page avant la sélection d'une étape -->
    <div *ngIf="!stepIsSelected">
      <div class="row justify-content-center mb-3">
        Sélectionnez une étape pour débuter la création de votre mail
      </div>
      <br />
      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-5">
          <div class="q-cadre-tuto">
            <div class="row no-gutters justify-content-center mt-3">
              <h5>
                <strong class="q-c-main"><i class="fas fa-users"></i> Etape 1 : </strong><strong> Sélection du/des destinataire(s) </strong>
              </h5>
            </div>
            <div class="row no-gutters justify-content-center">
              <small class="text-center"><i>Cette première étape sert à choisir les destinataires pour l'envoi du mail</i></small>
            </div>
            <br />
            <div class="row no-gutters justify-content-center">
              <h5>
                <strong class="q-c-main"><i class="fas fa-file-word"></i> Etape 2 : </strong><strong> Choix des documents</strong>
              </h5>
            </div>
            <div class="row no-gutters justify-content-center">
              <small class="text-center"><i>Suite du processus de création de votre mail, c'est ici que vous allez choisir vos documents à envoyer<br />(selection possible si un destinataire a été sélectionné à l'étape 1)</i></small>
            </div>
            <br />
            <div class="row no-gutters justify-content-center">
              <h5>
                <strong class="q-c-main"><i class="fas fa-eye"></i> Etape 3 : </strong><strong> Visualisation et envoi du mail</strong>
              </h5>
            </div>
            <div class="row no-gutters justify-content-center mb-3">
              <small class="text-center"><i>Ultime étape, la visualisation, la rédaction et l'envoie du mail</i></small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Step One : Sélection du/des destinataire(s) -->
  <div class="w-100">    
    <queoval-mail-step-one *ngIf="mailService.tabs[0].Active"
                           [ngClass]="{'d-none': !mailService.tabs[0].Active }"
                           class="col-12"></queoval-mail-step-one>
  </div>

  <!-- Step Two : Choix des documents  -->
  <div class="w-100">
    <queoval-mail-step-two *ngIf="mailService.tabs[1].Active"
                           [ngClass]="{'d-none': !mailService.tabs[1].Active }"
                           class="col-12"></queoval-mail-step-two>
  </div>

  <!-- Step Three : Visualisation et envoi du mail -->
  <div class="w-100">
    <queoval-mail-step-three *ngIf="mailService.tabs[2].Active"
                             [ngClass]="{'d-none': !mailService.tabs[2].Active }"
                             class="col-12"></queoval-mail-step-three>
  </div>

</div>
